/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createAsyncThunk } from "@reduxjs/toolkit";

import SetPasswordApi from "~/features/setPassword/SetPasswordApi";
import { PostSetPasswordRequestBody } from "~/features/setPassword/types";

export const setPasswordAsync = createAsyncThunk("setPassword", async (data: PostSetPasswordRequestBody) => {
  await SetPasswordApi.postSetPassword(data);

  return "set_password.success.message";
});
